// app/(lib)/actions/thankYouPageAction.ts
"use server";

import { thankYouPageService } from "../services/thankYouPageService";
import { extractDomain } from "../utils/domain";

/**
 * Fetch thank-you page content from API
 */
export async function getThankYouPageDataAction(franchiseeId?: string | null, language?: string | null) {
  try {
    const domain = await extractDomain();

    const thankYouPageData = await thankYouPageService.fetchByDomain(domain, franchiseeId, language);

    return {
      success: true,
      data: thankYouPageData,
    };
  } catch (error) {
    console.error("[getThankYouPageDataAction] Error:", error);
    return {
      success: false,
      data: null,
    };
  }
}
